export default 
{
	"progressbar-page-title": "página",
	"name-suffix": "Sufixo",
	"fileupload-desc-progress-message": "Upload {progress}",
	"required-if-greater-than-or-equal": "{property} é necessária quando {compareSource} é maior do que ou igual a {compareValue}.",
	"powered-by-cognito": "Alimentado por Forms Cognito.",
	"form-name-default": "Sem título",
	"field-choice-defaults": "Primeira Escolha|Segunda Escolha|Terceira Escolha",
	"additional-fee-default-label": "Taxa adicional",
	"authenticated-save-and-resume-email-dialog": "Envie um link por e-mail e volte ao seu formulário para concluir o envio.",
	"string-length-between": "{property} deve estar entre {min} e {max} caracteres.",
	"update-button-text": "Atualizar",
	"address-zip-code-invalid": "Zip Code deve ser formatado como #####-####.",
	"required-if-greater-than": "{property} é necessária quando {compareSource} é maior que {compareValue}.",
	"compare-before": "{property} deve ser antes de {compareSource}.",
	"compare-after": "{property} deve ser depois de {compareSource}.",
	"unsupported-browser-message": "Oh não! Você está usando um navegador não suportado. {a}Clique aqui {/a} para atualizar.",
	"shared-entry-email-subject": "Link Compartilhado",
	"send-button-text": "Enviar",
	"venmo-help-text": "Conecte-se ao Venmo para continuar com o pagamento.",
	"field-repeatingsection-item-label": "Item",
	"save-and-resume-email-not-sent-message": "Havia um problema.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} deve ser pelo menos {min}.",
	"entry-notification-full-entry-detail-link": "Veja detalhes plena entrada em cognitoforms.com.",
	"element-label-website": "Site",
	"element-label-signature": "Assinatura",
	"paypal-help-text": "Conecte-se ao PayPal para continuar com o pagamento.",
	"card-on-file-agreement-validation": "Você deve concordar em salvar seu cartão para futuras transações.",
	"marketing-button-4": "Construir O Seu Próprio Gratuitamente",
	"field-datepicker-now": "Agora",
	"save-and-resume-email-resume-button": "Continue agora",
	"field-datepicker-next-month": "Próximo mês",
	"quantity-remaining-text": "restante",
	"payment-declined": "Pagamento recusado",
	"required-if-before": "{property} é necessária quando {compareSource} é antes {compareValue}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} deve ser inferior a {compareSource}.",
	"entry-admin-link": "",
	"required-many": "{0} são necessários.",
	"save-and-resume-multiple-days-expiration-email-message": "Clique no link abaixo e retornar à sua forma dentro dos próximos {days} dias para completar sua submissão.",
	"string-length-at-least": "{property} deve ser no mínimo {mínimo} caracteres.",
	"credit-card-number": "Número de cartão de crédito",
	"range-on-or-before": "{property} deve ser igual ou anterior {max}.",
	"required-one": "{0} é obrigatório.",
	"fileupload-max-file-count-exceeded-message": "Só {maxFileCount} arquivos podem ser carregados.",
	"order-transaction-details-header": "Os detalhes da transação",
	"field-spinner-increase": "Aumentar",
	"payment-processing-fees": "Taxas de processamento",
	"payment": "Pagamento",
	"field-choice-other-fill-in": "Outros",
	"shared-entry-email-message": "Uma entrada foi compartilhado com você.",
	"shared-entry-workflow-link": "Visualize o formulário.",
	"required-if-exists": "{property} é necessária quando {compareSource} é especificado.",
	"concurrent-conflict-toast-message": "O envio falhou porque as informações no formulário foram alteradas. Por favor verifique e tente novamente.",
	"secured-by-paypal": "Protegido por",
	"range-on-or-after": "{property} deve ser em ou após {min}.",
	"payment-amount-due": "Valor Devido",
	"required-name-first-and-last": "Primeiro e Sobrenome são obrigatórios.",
	"required": "{property} é necessária.",
	"string-format-alphabetic": "{property} deve conter apenas letras.",
	"quantity-limit": "{property} quantidade excedida.",
	"field-spinner-decrease": "Diminuir",
	"field-repeatingsection-add-link-text": "Adicionar",
	"fileupload-max-size-exceeded-message": "Somente arquivos menor que {maxSize} MB pode ser carregado.",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "Não Capturado",
	"field-ratingscale-satisfied-unsatisfied-label": "Satisfeito/Insatisfeito",
	"range-between": "{property} deve estar entre {min} e {max}.",
	"field-ratingscale-agree-disagree-label": "Concordo/Discordo",
	"back-button-text": "Voltar",
	"address-country": "País",
	"order-not-found": "Nenhuma informação fim encontrado.",
	"field-ratingscale-satisfied-unsatisfied-options": "Muito insatisfeito|Insatisfeito|Neutral|Satisfeito|Muito satisfeitos",
	"entry-notification-entry-details-header": "Detalhes da entrada",
	"FALSE": "FALSO",
	"compare-greater-than-or-equal": "{property} deve ser maior do que ou igual a {compareSource}.",
	"receipt-notification-order-details-desc-header": "Descrição",
	"order-method-label": "Método",
	"order-total-label": "Ordem Total",
	"invalid-shared-link": "Inválido link compartilhado",
	"fileupload-zero-byte-file-message": "Zero byte arquivos não pode ser carregado.",
	"range-at-most": "{property} deve ser, no máximo, {max}.",
	"format-integer": "####",
	"order-date-label": "Data",
	"fileupload-dropzone-message": "ou arraste os arquivos aqui.",
	"shared-entry-view-link": "Veja a entrada compartilhada.",
	"format-currency": "R$ #.###,##",
	"string-length-at-most": "{property} deve ser, no máximo, {max} caracteres.",
	"entry-confirmation-footer-tagline": "Crie suas próprias formas de pagamento poderosos com",
	"submit-button-text": "Submeter",
	"marketing-msg": "Facilmente criar formas poderosas.",
	"required-if-on-or-after": "{property} é necessária quando {compareSource} é em ou após {compareValue}.",
	"card-on-file-agreement": "Eu concordo em salvar meu cartão para futuras transações.",
	"signature-draw": "desenhar",
	"address-zip-code": "Zip Code",
	"compare-on-or-after": "{property} deve ser em ou após {compareSource}.",
	"required-if-less-than-or-equal": "{property} é necessária quando {compareSource} é inferior ou igual a {compareValue}.",
	"field-datepicker-next-year": "Próximo ano",
	"change-button": "mudar",
	"fileupload-desc-size-in-bytes-message": "{size} bytes",
	"card-tab": "Cartão",
	"order-billing-info-header": "Informações de Cobrança",
	"entry-email-view-details-text": "Ver artigo completo em CognitoForms.com.",
	"save-and-resume-one-day-expiration-email-message": "Clique no link abaixo e retornar à sua forma no dia seguinte para completar sua submissão.",
	"credit-card-authentication-failed": "Cartão com falha na autenticação.",
	"compare-less-than-or-equal": "{property} deve ser menor do que ou igual a {compareSource}.",
	"receipt-notification-order-details-balance-due": "saldo devedor",
	"save-and-resume-multiple-days-expiration-message": "Copiar ou enviar e-mail o link abaixo e retornar à sua forma dentro dos próximos {days} dias para completar sua submissão.",
	"processing-fee-calculating-message": "Cálculo",
	"receipt-notification-trx-details-method": "Método",
	"field-choice-no-match": "Sem correspondência",
	"fileupload-invalid-file-type-message": "Só {allowedTypes} arquivos podem ser carregados.",
	"receipt-notification-trx-details-date": "Data",
	"credit-card-authorization": "Autorização de cartão",
	"address-line1": "Endereço Linha 1",
	"required-if-not-exists": "{property} é necessária quando {compareSource} não é especificado.",
	"required-if-not-equal": "{property} é necessária quando {compareSource} não é {compareValue}.",
	"marketing-button-2": "Construir O Seu Próprio Gratuitamente",
	"receipt-notification-billing-info-header": "Informações de Cobrança",
	"required-if-after": "{property} é necessária quando {compareSource} é after {compareValue}.",
	"element-label-name": "Nome",
	"required-if-equal": "{property} é necessária quando {compareSource} é {compareValue}.",
	"connected-to-paypal": "Conectado ao PayPal.",
	"people-form-email-quantity-exceeded-message": "O endereço de e-mail deve ser exclusivo.",
	"receipt-notification-order-details-subtotal": "subtotal",
	"shared-entry-edit-link": "Edite a entrada compartilhada.",
	"receipt-notification-trx-details-header": "Os detalhes da transação",
	"address-city": "Cidade",
	"receipt-notification-order-details-amount-paid": "Valor pago",
	"credit-card-invalid": "O cartão é inválido.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Você tem um novo envio do formulário.",
	"this-and-that": "{0} e {1}",
	"field-ratingscale-good-poor-label": "Bom/Pobres",
	"network-unavailable-message": "Rede indisponível, tente novamente mais tarde.",
	"dialog-close": "Fechar",
	"string-format-alphanumeric": "{property} deve conter apenas letras e números.",
	"credit-card": "Cartão de crédito",
	"remove-item": "Remover {item}",
	"receipt-notification-order-details-price-header": "Preço",
	"fileupload-upload-inprogress-message": "O upload do arquivo em andamento.",
	"public-terms-of-service-link-text": "Termos de Serviço",
	"save-and-resume-email-subject": "Salvar e Continuar link",
	"field-repeatingsection-remove-link-text": "Remover",
	"field-ratingscale-na-label": "N/A",
	"add-item": "Adicionar {item}",
	"field-toggle-options": "Sim/Não|Verdadeiro/Falso|Aberto/Fechado|Ativo/Inativo|Lido/Não lido",
	"order-submit-timeout": "Processamento do pedido está demorando muito. Por favor tente mais tarde a suaordem.",
	"listlength-at-most": "Por favor, especifique não mais do que {max} {property}.",
	"shared-entry-email-view-message": "Use o link abaixo para visualizar a entrada compartilhada.",
	"order-number-label": "Número",
	"card-declined": "Cartão recusado",
	"fileupload-default-upload-button-text": "Carregar",
	"name-prefix": "Título",
	"address-line2": "Endereço Linha 2",
	"element-label-email": "Email",
	"field-ratingscale-good-poor-options": "Muito pobre|Pobres|Média|Boa|Muito boa",
	"next-button-text": "Próxima",
	"question": "Pergunta",
	"address-postalcode": "Código Postal",
	"format-with-description": "{property} deve ser formatada como {description}.",
	"field-datepicker-prev-month": "Mês anterior",
	"name": "Nome",
	"receipt-notification-order-details-total-footer": "Total",
	"confirmation-message": "Obrigado por preencher o formulário. Sua resposta foi registrada.",
	"shared-entry-email-edit-message": "Use o link abaixo para editar a entrada compartilhada.",
	"field-default-label": "Sem título",
	"required-value": "{property} deve ser {value}.",
	"name-middle": "Meio",
	"fileupload-failed-upload-message": "{fileName} não conseguiu carregar.",
	"shared-entry-email-button-label": "Veja a entrada",
	"field-datepicker-year": "",
	"element-label-phone": "Telefone",
	"TRUE": "VERDADEIRO",
	"listlength-between": "Por favor, especifique entre {min} e {max} {property}.",
	"marketing-button-1": "Tente Agora",
	"entry-submission-error-heading": "Erro ao processar entrada",
	"order-not-found-message": "Nenhuma informação fim encontrado.",
	"format-without-description": "{property} não está formatada corretamente.",
	"name-last": "Sobrenome",
	"field-ratingscale-one-five-label": "Escala de 1 a 5",
	"listlength-at-least": "Especifique pelo menos {min} {property}.",
	"united-states": "Estados Unidos",
	"field-signature-captured": "Capturada",
	"compare-on-or-before": "{property} deve ser igual ou anterior {compareSource}.",
	"order-balance-due-label": "Saldo Devedor",
	"required-if-less-than": "{property} é necessária quando {compareSource} é inferior a {compareValue}.",
	"credit-card-postalcode": "Código Postal",
	"form-not-available-message": "Este formulário não está disponível no momento.",
	"element-label-address": "Endereço",
	"receipt-notification-trx-details-number": "Número",
	"public-submission-warning": "Por favor, não enviem senhas através de Cognito Forms.",
	"save-and-resume-no-expiration-email-message": "Clique no link abaixo para completar o preenchimento do seu formulário.",
	"fileupload-excluded-file-type-message": "Arquivos desse tipo não pode ser carregado.",
	"payment-subtotal": "Subtotal",
	"collapse": "Recolher",
	"save-button-text": "Salvar",
	"field-datepicker-prev-year": "Ano anterior",
	"signature-type": "escrever",
	"order-amount-minimum": "Valor Devido deve ser de pelo menos R $ 1,00.",
	"string-format-numeric": "{property} deve conter apenas números.",
	"entry-confirmation-entry-details-header": "Detalhes da entrada",
	"connected-to-venmo": "Conectado ao Venmo.",
	"format-percentage": "#,##%",
	"receipt-notification-header": "Recibo",
	"clear": "claro",
	"today": "Hoje",
	"required-name-last": "Sobrenome é necessária.",
	"marketing-button-3": "Tente Agora",
	"expand": "Expandir",
	"compare-greater-than": "{property} deve ser maior que {compareSource}.",
	"field-ratingscale-will-wont-label": "Vai/Não vai",
	"required-name-first": "Primeiro é necessário.",
	"save-and-resume-one-day-expiration-message": "Copiar ou enviar e-mail o link abaixo e retornar à sua forma no dia seguinte para completar sua submissão.",
	"required-asterisk": "necessária",
	"credit-card-required": "Cartão de crédito é necessária.",
	"address-state-province-region": "Estado / província / região",
	"save-and-resume-email-sent-message": "O e-mail foi enviado.",
	"workflow-action": "Ação",
	"field-ratingscale-will-wont-options": "Definitivamente não|Provavelmente não|Não tenho certeza|Provavelmente|Definitivamente",
	"save-and-resume-email-label": "Mande-me o meu link:",
	"field-ratingscale-agree-disagree-options": "Discordo totalmente|Discordo|Neutral|Concordo|Concordo totalmente",
	"order-exception-order-already-paid": "Esta ordem já tiver sido paga.",
	"fileupload-download-text": "Faça o download de",
	"address-state": "Estado",
	"allowed-values": "{property} não está na lista de valores permitidos.",
	"shared-entry-workflow-email-button-label": "Abrir formulário",
	"compare-equal": "{property} deve ser o mesmo que {compareSource}.",
	"field-datepicker-clear": "Limpar",
	"name-first": "Primeiro",
	"save-and-resume-message": "Seu progresso foi salvo.",
	"save-and-resume-no-expiration-message": "Copiar ou enviar e-mail o link abaixo e retorne ao seu formulário para completar sua submissão.",
	"entry-notification-view-details-text": "Ver detalhes",
	"order-exception-default-message": "Não foi possível processar a transação.",
	"public-report-abuse-link-text": "Denunciar abuso",
	"order-amount-paid": "Valor pago",
	"element-label-default": "Sem título",
	"countries": "Afeganistão|África do Sul|Albânia|Alemanha|Andorra|Angola|Anguilla|Antártica|Antígua e Barbuda|Antilhas Holandesas|Arábia Saudita|Argélia|Argentina|Armênia|Aruba|Austrália|Áustria|Azerbaijão|Bahamas|Bahrein|Bangladesh|Barbados|Bielorrússia|Bélgica|Belize|Benim|Bermudas|Bolívia|Bósnia e Herzegovina|Botsuana|Brasil|Brunei Darussalam|Bulgária|Burkina Faso|Burundi|Butão|Cabo Verde|Camarões|Camboja|Canadá|Catar|Cazaquistão|Chade|Chile|China|Chipre|Cidade do Vaticano (Santa Sé)|Cingapura|Colômbia|Comores|Congo, República of (Brazzaville)|Coreia, Popular Democrática \u0027 s Rep (Coreia do Norte)|Coreia, República da (Coreia do Sul)|Costa Rica|Costa do Marfim|Croácia|Cuba|Dinamarca|Djibouti|Dominica|Egito|El Salvador|Emirados Árabes Unidos|Equador|Eritreia|Eslováquia (República Eslovaca)|Eslovênia|Espanha|Estados Unidos|Estônia|Etiópia|Federação Russa|Fiji|Filipinas|Finlândia|França|Gabão|Gâmbia|Gana|Geórgia|Gibraltar|Grã-Bretanha|Grécia|Grenada|Gronelândia|Guadalupe|Guam|Guatemala|Guiana|Guiana francesa|Guiné|Guiné Equatorial|Guiné-Bissau|Haiti|Honduras|Hong Kong|Hungria|Iêmen|Ilha do Natal|Ilha da reunião|Ilha de Man|Ilha Pitcairn|Ilhas Faroés|Ilhas Cayman|Ilhas Cocos (Keeling)|Ilhas Cook|Ilhas Marianas do Norte|Ilhas Marshall|Ilhas Salomão|Ilhas Turcas e Caicos|Ilhas Virgens (britânicas)|Ilhas Virgens (EUA)|Ilhas Wallis e Futuna|Índia|Indonésia|Irã (República Islâmica do)|Iraque|Irlanda|Islândia|Israel|Itália|Jamaica|Japão|Jordânia|Kiribati|Kosovo|Kuaite|Lao, pessoas \u0027 s República Democrática|Lesoto|Letônia|Líbano|Libéria|Líbia|Ilhas Malvinas|Liechtenstein|Lituânia|Luxemburgo|Macau|Macedónia do Norte|Madagáscar|Malásia|Malawi|Maldivas|Mali|Malta|Marrocos|Martinica|Maurício|Mauritânia|Mayotte|México|Micronésia, Estados Federados da|Moçambique|Moldávia, República da|Mônaco|Mongólia|Montenegro|Montserrat|Mianmar, Birmânia|Namíbia|Nauru|Nepal|Nicarágua|Níger|Nigéria|Niue|Noruega|Nova Zelândia|Nova Caledônia|Omã|Países Baixos|Palau|Panamá|Papua-Nova Guiné|Paquistão|Paraguai|Peru|Polinésia francesa|Polônia|Porto Rico|Portugal|Quênia|Quirguistão|Reino Unido|República Dominicana|República Tcheca|República Centro-Africana|República Democrática do Congo (Kinshasa)|Romênia|Ruanda|Saara Ocidental|Saint Vincent e as Granadinas|Samoa|Samoa Americana|San Marino|Santa Lúcia|Santa Sé|São Cristóvão e Nevis|São Tomé e Príncipe|Senegal|Serra Leoa|Sérvia e Montenegro|Seychelles|Síria, República Árabe da Síria|Somália|Sri Lanka|Suazilândia|Sudão|Sudão do Sul|Suécia|Suíça|Suriname|Tailândia|Taiwan (República da China)|Tajiquistão|Tanzânia; oficialmente a República Unida da Tanzânia|Territórios franceses do Sul|Territórios palestinos|Tibet|Timor-Leste (East Timor)|Togo|Tokelau|Tonga|Trinidad e Tobago|Tunísia|Turcomenistão|Turquia|Tuvalu|Ucrânia|Uganda|Uruguai|Uzbequistão|Vanuatu|Venezuela|Vietname|Zâmbia|Zimbábue",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "Ordem deve conter pelo menos 1 item de linha.",
	"compare-not-equal": "{property} deve ser diferente do {compareSource}.",
	"entry-notification-footer": "Você está recebendo este e-mail porque você selecionou a opção de notificações de e-mail de recebimento na sua formaem Cognito Forms.",
	"save-and-resume-copy-link-label": "Copie o link para formulário:",
	"entry-confirmation-footer": "Você está recebendo este e-mail porque você completou uma transação com [Name].",
	"required-if-on-or-before": "{property} é necessária quando {compareSource} é em ou antes de {compareValue}.",
	"string-format": "{property} deve ser formatada como {formatDescription}.",
	"switch-to-drawing-mode": "Mude do modo de digitação para o modo de desenho.",
	"switch-to-typing-mode": "Mude do modo de desenho para o modo de digitação."
};
